module.exports = __webpack_public_path__ + "static/img/CgoRDGREgzmAIgS2AAXq1nR40hw741.7e68261.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGREgzmAIgS2AAXq1nR40hw741.jpg
// module id = SJjt
// module chunks = 73